// components/Services.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
// import './OurSupport.css';
import './Services.css';
import entrepriseImage from '../assets/entreprise.png';
import academieImage from '../assets/academi.jpeg';
import callImage from '../assets/call.jpg';
import EligibilityModal from './EligibilityModal';

const Services = ({ scrollToCalendar, openEligibilityModal }) => {
    const navigate = useNavigate();
    const [showEligibilityModal, setShowEligibilityModal] = useState(false);
    const [services, setServices] = useState([]);
    const [sectionTitle, setSectionTitle] = useState("Nos services");
    const [sectionSubtitle, setSectionSubtitle] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Désactiver le chargement et utiliser directement les données par défaut
        setServices(getDefaultServices());
        setLoading(false);

        // fetchRubriqueData();
    }, []);

    const fetchRubriqueData = async () => {
        // try {
        //     setLoading(true);
        //   const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Nos-services-1`,)


        //     if (!response.ok) {
        //         throw new Error(`HTTP error! status: ${response.status}`);
        //     }

        //     const data = await response.json();

        //     if (data.success && data.data) {
        //         const rubriqueData = data.data;
        //         setSectionTitle(rubriqueData.titre || "Nos services");
        //         setSectionSubtitle(rubriqueData.descriptif || "Découvrez notre expertise complète en formation, centre d'examen et consulting pour accompagner votre transformation et votre réussite.");

        //         if (rubriqueData.articles && rubriqueData.articles.length > 0) {
        //             // LIMITER À 2 BLOCS SEULEMENT
        //             const articlesToShow = rubriqueData.articles.slice(0, 2);

        //             const formattedServices = articlesToShow.map((article, index) => {
        //                 let description = '';
        //                 let items = [];

        //                 if (article.texte) {
        //                     const cleanedText = article.texte.replace(/\r\n/g, ' ');

        //                     try {
        //                         const parser = new DOMParser();
        //                         const doc = parser.parseFromString(cleanedText, 'text/html');

        //                         const firstParagraph = doc.querySelector('p');
        //                         if (firstParagraph) {
        //                             description = firstParagraph.textContent.trim();
        //                         }

        //                         const listItems = doc.querySelectorAll('li');
        //                         if (listItems.length > 0) {
        //                             items = Array.from(listItems).map(li => {
        //                                 return li.textContent
        //                                     .replace(/✓/g, '')
        //                                     .replace(/\s+/g, ' ')
        //                                     .trim();
        //                             });
        //                         }

        //                     } catch (parseError) {
        //                         console.warn('Erreur lors du parsing HTML, fallback sur regex:', parseError);

        //                         const descMatch = cleanedText.match(/<p[^>]*>([^<]*)<\/p>/);
        //                         if (descMatch && descMatch[1]) {
        //                             description = descMatch[1].trim();
        //                         }

        //                         const liRegex = /<li[^>]*>((?:[^<]|<(?!\/li>))*?)<\/li>/g;
        //                         let liMatch;
        //                         while ((liMatch = liRegex.exec(cleanedText)) !== null) {
        //                             const content = liMatch[1]
        //                                 .replace(/<[^>]+>/g, '')
        //                                 .replace(/✓/g, '')
        //                                 .replace(/\s+/g, ' ')
        //                                 .trim();

        //                             if (content) {
        //                                 items.push(content);
        //                             }
        //                         }
        //                     }
        //                 }

        //                 if (!description && article.texte_short) {
        //                     description = article.texte_short;
        //                 }

        //                 if (items.length === 0 && article.texte) {
        //                     const textWithoutTags = article.texte.replace(/<[^>]+>/g, '');
        //                     const sentences = textWithoutTags.split(/[•\-\*]/).filter(s => s.trim());
        //                     if (sentences.length > 1) {
        //                         items = sentences.slice(1, 8).map(s => s.trim()).filter(s => s);
        //                     }
        //                 }

        //                 if (items.length === 0) {
        //                     items = ["Service détaillé disponible"];
        //                 }

        //                 return {
        //                     id: article.id_article,
        //                     title: article.titre,
        //                     description: description || "Description non disponible",
        //                     items: items,
        //                     buttonText: getButtonText(article.titre),
        //                     borderColor: getBorderColor(index)
        //                 };
        //             });

        //             setServices(formattedServices);
        //         } else {
        //             // Données par défaut pour 2 blocs
        //             setServices(getDefaultServices());
        //         }
        //     } else {
        //         throw new Error('Données de rubrique non disponibles');
        //     }

        // } catch (err) {
        //     console.error('Erreur lors de la récupération des données:', err);
        //     setError(err.message);
        //     // Services par défaut en cas d'erreur (2 blocs)
        //     setServices(getDefaultServices());
        // } finally {
        //     setLoading(false);
        // }
    };

    const getBorderColor = (index) => {
        const colors = ["#0a3764", "#94bf3e"];
        return colors[index % colors.length];
    };

    // Services par défaut pour 2 blocs
    const getDefaultServices = () => [
        {
            id: 1,
            title: "Entreprise",
            description: "Vos projets accusent des retards ou dépassent les budgets ?",
            text: "Dans de nombreuses organisations, les projets échouent non pas par manque de volonté, mais par manque de méthode, de coordination et de compétences structurées. Nous vous aidons à identifier rapidement les causes de ces dysfonctionnements et à mettre en place des solutions concrètes.",
            buttonText: "Je veux réussir mes projets",
            borderColor: "#94bf3e",
            linkAccess: "/entreprises",
            imageBanner: entrepriseImage,
            name: "Entreprise"
        },
        {
            id: 2,
            title: "Académie",
            description: "Obtenez une certification reconnue et accélérez votre carrière !",
            text: "Préparez efficacement vos certifications : PMP<sup>®</sup>, CAPM<sup>®</sup>, PMI-CP<sup>™</sup>, PSM 1<sup>™</sup>, ITIL 5<sup>®</sup> avec un accompagnement structuré et orienté réussite. Notre parcours d'apprentissage IPCP (INOVACT Project Controls & Performance) vous fournit les aptitudes théoriques et pratiques pour planifier, exécuter et maîtriser tout type de projet.",
            buttonText: "Je veux renforcer mes capacités",
            borderColor: "#0a3764",
            linkAccess: "/formations",
            imageBanner: academieImage,
            name: "Academie"
        }
    ];

    // Composant de spinner de chargement
    const LoadingSpinner = ({ size = "40px", color = "#1a3c5e" }) => (
        <div style={{
            textAlign: "center",
            padding: "3rem",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <div style={{
                width: size,
                height: size,
                border: `3px solid #f3f3f3`,
                borderTop: `3px solid ${color}`,
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginBottom: "1rem"
            }}></div>

            <style>
                {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );

    if (loading) {
        return (
            <section className="section our-support" id="services">
                <div className="contenir">
                    {/* <h2 className="section-title">Nos services</h2> */}
                    <p className="section-subtitle">
                        Chargement des services...
                    </p>
                    <div className="services-grid" style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                        gap: '2rem',
                    }}>
                        {[1, 2].map(i => (
                            <div key={i} className="service-card loading" style={{
                                backgroundColor: 'white',
                                borderRadius: '0px',
                                padding: '2rem',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.35)',
                                height: '100%'
                            }}>
                                <div className="loading-placeholder" style={{ height: '24px', width: '60%', marginBottom: '1rem' }}></div>
                                <div className="loading-placeholder" style={{ height: '60px', marginBottom: '1rem' }}></div>
                                <div className="loading-placeholder" style={{ height: '20px', marginBottom: '0.5rem' }}></div>
                                <div className="loading-placeholder" style={{ height: '20px', marginBottom: '0.5rem' }}></div>
                                <div className="loading-placeholder" style={{ height: '20px', marginBottom: '1rem' }}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="section our-support" id="services">
                <div className="contenir">
                    {/* <h2 className="section-title">Nos services</h2> */}
                    <p className="section-subtitle" style={{ color: '#ff6b6b' }}>
                        Erreur de chargement : {error}
                    </p>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className="section our-support" id="services">
                <div className="contenir">
                    {/* <h2 className="section-title">{sectionTitle}</h2>
                    <p className="section-subtitle">
                        {sectionSubtitle}
                    </p> */}

                    
                    {/* Section Investissement et Tourisme */}
                    <div className="sections-grid">
                        {services.map((service) => (
                        <div className="section-investissement">
                            <div className="section-content">
                                <div className="text-content">
                                    <div className="section-header mb-1">
                                        <h2 className="section-titre" style={{ textTransform: "uppercase" }}>{service.title}</h2>
                                    </div>
                                    <div className="section-body">
                                        {loading ? (
                                            <LoadingSpinner size="30px" color="#1a3c5e" />
                                        ) : service ? (
                                            <>
                                                <h4 className="section-sous-titre my-1 mb-2" >{service.description}</h4>
                                                <div className="section-texte" dangerouslySetInnerHTML={{ __html: service.text }} />
                                                <Link to={service.linkAccess} className="lien-decouverte">
                                                    {service.buttonText} ↗
                                                </Link>
                                            </>
                                        ) : (
                                            <div className="info-indisponible" style={{
                                                padding: '2rem',
                                                textAlign: 'center',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                color: '#6c757d',
                                                fontSize: '1.1rem'
                                            }}>
                                                Information indisponible
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="image-content">
                                    {loading ? (
                                        <LoadingSpinner size="30px" color="#1a3c5e" />
                                    ) : service && service.imageBanner ? (
                                        <img
                                            src={service.imageBanner}
                                            alt={service.name }
                                            className="section-image"
                                        />
                                    ) : (
                                        <div className="image-placeholder" style={{
                                            width: '100%',
                                            height: '100%',
                                            minHeight: '300px',
                                            backgroundColor: '#e9ecef',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#6c757d',
                                            fontSize: '1rem'
                                        }}>
                                            Information indisponible
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        ))}

                        
                    </div>
                </div>
            </section>

            
        </>
    );
};

export default Services;